/* @flow */
import { observable, action, computed } from 'mobx';
import { ApiModel } from 'api/ApiModel';
import { errorHandlerService } from '../services/ServiceRegistry';
import type { ApiType } from '../tables/components/ReportView/types';

export default class WelcomePageStore extends ApiModel {
  @observable loading = false;
  @observable searchResults = [];
  @observable selectedItemIndex = 0;
  @observable noSearchResults = false;

  @computed get selectedItem() {
    if (this.searchResults.length > 0) {
      return this.searchResults[this.selectedItemIndex];
    }
  }

  set selectedItem(selectedItemIndex) {
    this.selectedItemIndex = selectedItemIndex;
  }

  @action
  async loadSearchResults(searchText: string, search: string, config: Object): Promise<void> {
    this.loading = true;

    const { url, apiType, idKey } = config;

    if (!searchText) {
      this.loading = false;
      this.noSearchResults = false;
      return (this.searchResults = []);
    }

    try {
      const results = await this.api.getResource(`${url}?search=${search}`);

      switch (apiType) {
        case 'AzureSearch':
          this.noSearchResults = results.value.length === 0;
          this.searchResults = results.value.map(item => ({ ...item, id: item[idKey] }));
          break;
        case 'SQL':
        default:
          this.noSearchResults = results.data.length === 0;
          this.searchResults = results.data;
      }
    } catch (err) {
      errorHandlerService.handleException(err);
    }

    this.loading = false;
  }
}
